import { Pressable, StyleSheet, View } from 'react-native';
import { AlertTriangle, ChevronRight } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import type { WeakPointViewModel } from '../../types/learningAnalysis';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type WeakPointListProps = {
  weakPoints: WeakPointViewModel[];
  onPressWeakPoint: (weakPoint: WeakPointViewModel) => void;
};

export function WeakPointList({ weakPoints, onPressWeakPoint }: WeakPointListProps) {
  if (!weakPoints.length) {
    return null;
  }

  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <AlertTriangle size={18} color={tokens.colors.warning} />
        <AppText variant="body" weight="bold">
          薄弱点检测
        </AppText>
      </View>
      {weakPoints.map((weakPoint) => (
        <Pressable
          key={weakPoint.id}
          accessibilityRole="button"
          onPress={() => onPressWeakPoint(weakPoint)}
          style={({ pressed }) => [styles.row, pressed ? styles.pressed : null]}
        >
          <View style={styles.copy}>
            <AppText variant="body" weight="semibold">
              {weakPoint.title}
            </AppText>
            <AppText variant="caption" tone="muted">
              {weakPoint.subject} · {weakPoint.priorityLabel}
            </AppText>
          </View>
          <ChevronRight size={18} color={tokens.colors.textMuted} />
        </Pressable>
      ))}
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacing.sm,
  },
  row: {
    minHeight: 52,
    borderRadius: tokens.radius.md,
    paddingHorizontal: tokens.spacing.md,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: tokens.colors.warningSoft,
  },
  copy: {
    flex: 1,
    gap: 2,
  },
  pressed: {
    opacity: 0.86,
  },
});
